.sort {
  cursor: pointer;
  color: gray;
}

.sortActive {
  color: red;
}
